import React from 'react';

import { useSelector } from 'react-redux';

import { PropTypes } from 'prop-types';

import FieldText from '../commons/FieldText';
import FieldNumber from '../commons/FieldNumber';
import FieldSelect from '../commons/FieldSelect';

const AdditionalData = ({ isInsuredPerson }) => {
  const nationalities = useSelector((state) => state.catalogs.nationalities);
  const DEFAULT_NATIONALITY = {
    value: 1,
    name: 'Mexicana',
  };
  const SOURCE_INCOME = 'Canales alternos';
  const ID_ACTIVITY_BY_DEFAULT = 888;

  return (
    <div>
      <h3>Adicionales</h3>
      <hr className="solid" />
      <div className="field-row">
        <FieldNumber
          label="Actividad"
          required
          keyLabel="name"
          keyName="id"
          valueDefinied={ID_ACTIVITY_BY_DEFAULT}
          name="activity"
          disabled
          hidden />
        <FieldText
          label="Fuente de ingresos"
          name="sourceIncome"
          valueDefinied={SOURCE_INCOME}
          required
          disabled
          hidden />
      </div>
      <div className="field-row">
        <FieldSelect
          label="Nacionalidad"
          keyLabel="name"
          keyName="id"
          required
          name="nationality"
          list={nationalities}
          defaultValue={DEFAULT_NATIONALITY.value} />
        {isInsuredPerson && (
          <FieldText
            label="¿Conductor > 30 años?"
            required={false}
            keyLabel="label"
            keyValue="value"
            valueDefinied="true"
            name="isOlderThan30"
            disabled
            hidden />
        )}
      </div>
    </div>
  );
};

AdditionalData.propTypes = {
  isInsuredPerson: PropTypes.bool.isRequired,
};

export default AdditionalData;
